/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  // * indie folks
  {
    _id: "2Q466ZPyNAo",
    title: "Hollow Coves - The Woods (Official Music Video)",
    description: "Keep Listening",
    creator: "Hollow Coves",
    categoryName: "Indie Folk",
  },
  {
    _id: "b3LJlZBWI8w",
    title: "SMYL - Where's My Love (Acoustic)",
    description: "Keep Listening",
    creator: "Indie Air",
    categoryName: "Indie Folk",
  },
  {
    _id: "BYFjmKU54ks",
    title: "Handsome Ghost - Weeds (Official Music Video)",
    description: "Keep Listening",
    creator: "Handsome Ghost",
    categoryName: "Indie Folk",
  },
  {
    _id: "j6Keg3XKKjM",
    title: "Hollow Coves - These Memories (Official Music Video)",
    description: "Keep Listening",
    creator: "Hollow Coves",
    categoryName: "Indie Folk",
  },
  {
    _id: "prFtgvSwu3Y",
    title: "Hollow Coves - Patience (Live Acoustic Session)",
    description: "Keep Listening",
    creator: "Hollow Coves",
    categoryName: "Indie Folk",
  },
  {
    _id: "Qxqi12Nj1ig",
    title: "Hollow Coves - Anew (Official Video)",
    description: "Keep Listening",
    creator: "Hollow Coves",
    categoryName: "Indie Folk",
  },
  {
    _id: "xhg3eYdEYNo",
    title: "SYML - 'Girl' [Official Music Video]",
    description: "Keep Listening",
    creator: "SYML",
    categoryName: "Indie Folk",
  },
  // * acoustic
  {
    _id: "Oge-Eaik0qY",
    title: "Raghav Meattle - City Life | Official Music Video",
    description: "Keep Listening",
    creator: "Raghav Meattle",
    categoryName: "Acoustic",
  },
  {
    _id: "TS5desK4-N0",
    title: "Phir Se Udd Chala | Rockstar | Raghav Chaitanya",
    description: "Keep Listening",
    creator: "Raghav Chaitanya",
    categoryName: "Acoustic",
  },
  // * classical indian
  {
    _id: "tcJRx4adueg",
    title: "Anupam Roy - Ocean Calls My Name (Official Lyric Video)",
    description: "Keep Listening",
    creator: "Anupam Roy",
    categoryName: " Classical Indian",
  },
  {
    _id: "1gukvtH_a3I",
    title:
      "Chaudhary - Amit Trivedi feat Mame Khan, Coke Studio @ MTV Season 2",
    description: "Keep Listening",
    creator: "Coke Studio India",
    categoryName: "Classical Indian",
  },
  {
    _id: "_-65XaYsn8w",
    title:
      "'Bannado' - Sachin-Jigar, Tochi Raina, Bhungarkhan Manganiar & Group - Coke Studio@MTV Season 4",
    description: "Keep Listening",
    creator: "Coke Studio India",
    categoryName: "Classical Indian",
  },
  {
    _id: "6M26SU4-D20",
    title:
      "Peele Amiras- Lost & Found | Kabir Cafe Ft Shekhar Ravjiani | Sabr | 2021",
    description: "Keep Listening",
    creator: "Kabir Cafe Official",
    categoryName: "Classical Indian",
  },
  // * motivational
  {
    _id: "mk48xRzuNvA",
    title: "The Script - Hall of Fame (Official Video) ft. will.i.am",
    description: "Keep Listening",
    creator: "The Script",
    categoryName: "Motivational",
  },
  {
    _id: "gOsM-DYAEhY",
    title: "Imagine Dragons - Whatever It Takes",
    description: "Keep Listening",
    creator: "Imagine Dragons",
    categoryName: "Motivational",
  },
  {
    _id: "0I647GU3Jsc",
    title: "Imagine Dragons - Natural",
    description: "Keep Listening",
    creator: "Imagine Dragons",
    categoryName: "Motivational",
  },
  {
    _id: "ktvTqknDobU",
    title: "Imagine Dragons - Radioactive",
    description: "Keep Listening",
    creator: "Imagine Dragons",
    categoryName: "Motivational",
  },
  {
    _id: "WIm1GgfRz6M",
    title: "The Script - Superheroes (Official Video)",
    description: "Keep Listening",
    creator: "The Script",
    categoryName: "Motivational",
  },
  {
    _id: "vNfgVjZF8_4",
    title: "OneRepublic - Someday (Official Music Video)",
    description: "Keep Listening",
    creator: "One Republic",
    categoryName: "Motivational",
  },
];
